<template>
    <div class="common-space-between selectMonth">
         <div class="common-items-center">
            <div class="btn" :class='[indexNo==index? "active":""]' v-for="(item,index) in listBtn" @click="getVal(index)">{{item.title}}</div>
            <Month :showTitle="false" ref="mouth" @getDate="getDate"></Month>
         </div>
         <div class="common-items-center">
            <div class="text">{{startData}} ~ {{endData}}</div>  
         </div>
    </div>
</template>
<script>
import { getDateFun } from '@/utils/util'
import Month from '@/components/component-block/block-month.vue'
export default {
    components:{
        Month:Month
    },
    props:{
       startData:{
         type:String,
         default:""
       },
       endData:{
         type:String,
         default:""
       },
    },
    data: ()=>({
       indexNo:0, 
       listBtn:[]
    }),
    mounted(){
       this.listBtn =  this.$store.state.conText.selectBtn
       this.getVal(0)
    },
    methods:{
        getDateType(type){

            let startTime = '';
            let endTime = '';

            if(type == 1){
                // 获取近一周的时间
                let currentDate = new Date()
                //获取当前时间的毫秒数 一小时 = 3600 * 1000 3600 60分钟 1000 1秒 24 一天小时 7 天
                startTime = currentDate.getTime() - 3600 * 1000 * 24 * 7    
                //获取当前时间的毫秒数
                endTime = currentDate.getTime()
                //输出近一周的开始时间和结束时间
                console.log('近一周',startTime,endTime);
            }else if(type == 2){
                // 获取近一月的时间
                let currentDate = new Date()
                // 获取当前时间
                startTime = currentDate.getTime() - 3600 * 1000 * 24 * 30
                // 计算从当前时间减去1个月的时间
                endTime = currentDate.getTime() 
                // 计算从当前时间起，到今天的时间
                console.log('近一个月',startTime,endTime);
            }else if(type == 3){
                // 获取近一年时间
                let currentDate = new Date()
                //获取当前时间
                startTime = currentDate.getTime() - 3600 * 1000 * 24 * 365
                //计算过去一年的时间
                endTime = currentDate.getTime()
                console.log('近一年',startTime,endTime)
                endTime = currentDate.getTime()
                // 计算从开始时间到现在的毫秒数
                console.log('近一年',startTime,endTime)
            }

            return {
                startTime:getDateFun(new Date(startTime),'yyyy-MM-dd 00:00:00',true),
                endTime:getDateFun(new Date(endTime),'yyyy-MM-dd 23:59:59',true)
            }
        },
        getVal(indexNo){
            
            console.log('index',indexNo)

           this.indexNo = indexNo

           let date = this.getDateType(indexNo+1);

           let parms = {
                endTime: date.endTime,
                startTime: date.startTime,
                type: this.listBtn[indexNo].val  
           }

           
        console.log('=======',this.$store.state.conText.selectBtn)

           this.$refs.mouth.clear()
           this.$emit("fMethod", parms) 
        },
        getDate(ev){
           this.indexNo = 4
           let parms = {
                endTime: ev.endDate,
                startTime: ev.startDate,
                type:4
           }
           this.$emit("fMethod", parms) 
        }
    },
}
</script>
<style lang="scss" scoped>
    .btn{
      width: 60px;
      height: 30px;
      font-size: 14px;
      color: #474E5F;
      line-height: 30px;
      text-align: center;
      cursor: pointer; 
      border:1px solid #0095FF;
      border-radius:4px;
      margin-right: 10px;
      color: #0095FF;
    }
    .btn.active{
        color: #EDFAFF;
        background: #0095FF;
    }
    .number{
        font-size: 42px;
        color: #FE564E;
        font-weight: 700;
        margin-right: 22px;
    }
    .text{
        font-size: 16px;
        color: #474E5F;
        font-weight: 400;
    }
</style>
